var styles = {"root":"quarters_root__NOPHK","year":"quarters_year__18P9F","withQuarters":"quarters_withQuarters__1wcb2","disabled":"quarters_disabled__VEEFU","selected":"quarters_selected__2DTub","active":"quarters_active__iK0bh","first":"quarters_first__EK0fJ","last":"quarters_last__XJIMs"};

export default styles;
